module.exports = __webpack_public_path__ + "img/rectangle-table-8.937360c8.png";